import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Stufe 1 von 3: Sektionstitel. 13 px / 600 / --fg-1, Icon in --fg-7. Eine pro Sektion. */
export function SectionHeader({ title, icon, actions, style = {} }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, paddingBottom: 10, ...style }}>
      <span style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "var(--type-section-title-size)", fontWeight: "var(--fw-semibold)", color: "var(--fg-1)" }}>
        {icon ? <Icon name={icon} size={15} style={{ color: "var(--fg-7)" }} /> : null}{title}
      </span>
      {actions ? <div style={{ display: "flex", alignItems: "center", gap: 5 }}>{actions}</div> : null}
    </div>
  );
}

/* Stufe 2: Zwischenüberschrift. 12 px / 600 / --fg-2. Gliedert eine Sektion in Gruppen. */
export function GroupHeading({ children, style = {} }) {
  return <span style={{ display: "block", fontSize: "var(--type-group-heading-size)", fontWeight: "var(--fw-semibold)", color: "var(--fg-2)", padding: "0 0 2px", ...style }}>{children}</span>;
}

/* Stufe 3: Unterblock. 11.5 px / 500 / --fg-8 mit auslaufender Trennlinie in --line-f. */
export function SubBlockHeading({ children, inset = false, style = {} }) {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, paddingTop: inset ? 8 : 0, marginBottom: 12, ...style }}>
      <span style={{ fontSize: "var(--type-subblock-size)", fontWeight: "var(--fw-medium)", color: "var(--fg-8)", whiteSpace: "nowrap" }}>{children}</span>
      <span style={{ flex: 1, height: 1, background: "var(--line-f)" }} />
    </span>
  );
}
